/* Tapestry Coffee Quiz ("Find your coffee")
 * Coffees come from the section's JSON (built from your products), so new coffees join automatically.
 * Matching uses each coffee's roast / acidity / body / sweetness (1–5) + tasting-note keywords.
 */
(function () {
  'use strict';

  var QUESTIONS = [
    {
      id: 'take', q: 'First things first: how do you take it?',
      opts: [
        { v: 'black', e: '⚫', t: 'Black. Always.', n: { acidity: 1, roast: -0.5 } },
        { v: 'milk', e: '🥛', t: 'A splash of milk or cream', n: { body: 1, roast: 0.5, acidity: -0.5 } },
        { v: 'sweet', e: '🍮', t: 'Cream and sugar, thanks', n: { body: 1.5, roast: 1, sweetness: 0.5, acidity: -1 } },
        { v: 'depends', e: '🤷', t: 'Depends on the day', n: {} }
      ]
    },
    {
      id: 'brew', q: 'How do you make it most mornings?', grid: true,
      opts: [
        { v: 'drip', e: '☕', t: 'Drip coffee maker', n: {} },
        { v: 'pourover', e: '⏳', t: 'Pour over', n: { acidity: 1, roast: -0.5, body: -0.5 } },
        { v: 'french', e: '🫖', t: 'French press', n: { body: 1 } },
        { v: 'espresso', e: '🔩', t: 'Espresso machine', n: { body: 0.5, sweetness: 0.5 } },
        { v: 'cold', e: '🧊', t: 'Cold brew', n: { body: 0.5, sweetness: 0.5, acidity: -1 } },
        { v: 'other', e: '🔘', t: 'Something else', s: 'AeroPress, moka pot, pods', n: {} }
      ]
    },
    {
      id: 'grind', q: 'Do you grind your beans at home?',
      opts: [
        { v: 'whole', e: '🌀', t: 'Yes, I grind fresh', n: {} },
        { v: 'ground', e: '🛍️', t: 'No, I buy it ground', n: {} }
      ]
    },
    {
      id: 'flavor', q: 'Which of these sounds best?', grid: true,
      opts: [
        { v: 'chocolate', e: '🍫', t: 'Chocolate & nutty', s: 'Cozy, rich, classic', n: { roast: 0.5, body: 0.5, acidity: -0.5 } },
        { v: 'fruity', e: '🍓', t: 'Bright & fruity', s: 'Berries, citrus, juicy', n: { acidity: 1 } },
        { v: 'caramel', e: '🍯', t: 'Sweet & caramelly', s: 'Brown sugar, honey, toffee', n: { sweetness: 1 } },
        { v: 'floral', e: '🌸', t: 'Light & floral', s: 'Delicate, tea-like', n: { roast: -1, acidity: 0.5, body: -1 } }
      ]
    },
    {
      id: 'adventure', q: 'How adventurous is your cup?',
      opts: [
        { v: 'classic', e: '🏠', t: 'Keep it classic', s: 'Smooth, familiar, easy to love', n: { acidity: -0.5 } },
        { v: 'some', e: '🧭', t: 'A little adventure', s: 'Something new, nothing too wild', n: {} },
        { v: 'surprise', e: '🎲', t: 'Surprise me', s: 'I trust the roaster', n: { acidity: 0.5 } }
      ]
    },
    {
      id: 'caffeine', q: 'Last one: how about caffeine?',
      opts: [
        { v: 'full', e: '☀️', t: 'Full caffeine, always', n: {} },
        { v: 'later', e: '🌙', t: 'Caffeine, plus a decaf for later', n: {} },
        { v: 'decaf', e: '😴', t: 'Decaf only, please', n: {} }
      ]
    }
  ];

  var FLAVOR_WORDS = {
    chocolate: ['chocolate', 'cacao', 'cocoa', 'nut', 'peanut', 'almond', 'pecan', 'hazelnut', 'walnut', 'praline', 'toffee', 'malt', 'graham'],
    fruity: ['berry', 'berries', 'cherry', 'strawberry', 'blueberry', 'raspberry', 'blackberry', 'currant', 'citrus', 'orange', 'lemon', 'lime', 'grapefruit', 'marmalade', 'jam', 'stone fruit', 'peach', 'apricot', 'plum', 'apple', 'grape', 'tropical', 'mango', 'pineapple', 'fruit'],
    caramel: ['caramel', 'toffee', 'brown sugar', 'honey', 'molasses', 'maple', 'candied', 'praline', 'vanilla', 'butterscotch', 'sugar', 'syrup'],
    floral: ['floral', 'jasmine', 'tea', 'bergamot', 'lavender', 'rose', 'hibiscus', 'blossom', 'lemongrass', 'chamomile']
  };
  var WEIGHTS = { roast: 1.2, acidity: 1, body: 0.8, sweetness: 0.6 };
  var STORE_KEY = 'tpq_answers_v1';

  function $(root, sel) { return root.querySelector(sel); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  function formatMoney(cents, format) {
    var amount = (cents / 100);
    var fmt = format || '${{amount}}';
    var withCommas = function (num, dec) { return num.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas(amount, 0);
      if (key === 'amount_with_comma_separator') return amount.toFixed(2).replace('.', ',');
      return withCommas(amount, 2);
    }).replace(/<[^>]*>/g, '');
  }

  function splitNotes(str) {
    if (!str) return [];
    return String(str).replace(/\s+and\s+/gi, ', ').replace(/\s*&\s*/g, ', ').replace(/[;.]/g, ',')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4)
      .map(function (s) { return s.charAt(0).toUpperCase() + s.slice(1); });
  }

  // ---------- analytics ----------
  // GA4 property that should receive quiz events (Shopify's Google channel loads gtag on the page).
  var GA4_ID = 'G-60E89SB12P';
  var ENTRY_VALUES = ['homepage', 'coffee_collection', 'side_tab', 'blog', 'direct', 'email', 'other'];

  function readJSON(store, key) { try { return JSON.parse(store.getItem(key) || 'null'); } catch (e) { return null; } }

  // Where did this quiz visit come from? Links into the quiz carry ?src=..., otherwise we infer it.
  function attribution() {
    var params = new URLSearchParams(location.search);
    var cached = readJSON(sessionStorage, 'tpq_attr');
    var src = (params.get('src') || '').toLowerCase();
    if (cached && !src && !params.get('utm_source')) return cached;

    var entry = 'other';
    var utmSource = (params.get('utm_source') || '').toLowerCase();
    var utmMedium = (params.get('utm_medium') || '').toLowerCase();
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer) : ''; } catch (e) { ref = ''; }

    if (ENTRY_VALUES.indexOf(src) !== -1) entry = src;
    else if (utmMedium === 'email' || utmSource.indexOf('klaviyo') !== -1) entry = 'email';
    else if (ref && ref.host === location.host) {
      if (ref.pathname === '/' ) entry = 'homepage';
      else if (ref.pathname.indexOf('/collections') === 0) entry = 'coffee_collection';
      else if (ref.pathname.indexOf('/blogs') === 0) entry = 'blog';
      else entry = 'other';
    } else if (!ref) entry = 'direct';

    var session = readJSON(sessionStorage, 'tp_st') || {};
    var first = readJSON(localStorage, 'tp_ft') || {};
    var out = {
      quiz_entry_point: entry,
      utm_source: params.get('utm_source') || session.utm_source || '',
      utm_medium: params.get('utm_medium') || session.utm_medium || '',
      utm_campaign: params.get('utm_campaign') || session.utm_campaign || '',
      session_source: session.source || '',
      first_source: first.source || '',
      first_medium: first.medium || ''
    };
    try { sessionStorage.setItem('tpq_attr', JSON.stringify(out)); } catch (e) {}
    return out;
  }

  function track(name, data) {
    var params = Object.assign({}, attribution(), data || {});
    Object.keys(params).forEach(function (k) { if (params[k] === '' || params[k] == null) delete params[k]; });
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ send_to: GA4_ID }, params));
    } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, params); } catch (e) {}
  }

  function Quiz(root) {
    this.root = root;
    this.stage = $(root, '[data-tpq-stage]');
    this.resultsEl = $(root, '[data-tpq-results]');
    this.intro = $(root, '[data-tpq-intro]');
    try { this.coffees = JSON.parse($(root, '[data-tpq-coffees]').textContent) || []; } catch (e) { this.coffees = []; }
    try { this.settings = JSON.parse($(root, '[data-tpq-settings]').textContent) || {}; } catch (e) { this.settings = {}; }
    this.answers = {};
    this.step = 0;
    this.started = false;

    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    track('coffee_quiz_viewed', { returning_with_results: !!(saved && saved.done) });
    if (saved && saved.done && saved.answers) {
      this.answers = saved.answers;
      this.showResults(true);
    } else {
      this.renderQuestion();
    }
  }

  // Espresso drinkers skip the grind question: we only sell whole bean or a drip grind, so espresso is always whole bean.
  Quiz.prototype.isEspresso = function () { return this.answers.brew === 'espresso'; };
  Quiz.prototype.visible = function () {
    var self = this;
    return QUESTIONS.filter(function (q) { return !(q.id === 'grind' && self.isEspresso()); });
  };

  Quiz.prototype.renderQuestion = function () {
    var self = this;
    var list = this.visible();
    if (this.step > list.length - 1) this.step = list.length - 1;
    var q = list[this.step];
    var pct = Math.round((this.step / list.length) * 100);
    // Total is left off on purpose: espresso drinkers skip the grind question, so the count would change mid-quiz
    var html = '<div class="tpq__progress"><span class="tpq__step">Question ' + (this.step + 1) + '</span>' +
      '<span class="tpq__bar"><span style="width:' + Math.max(pct, 4) + '%"></span></span></div>' +
      '<h2 class="tpq__q">' + esc(q.q) + '</h2>' +
      '<div class="tpq__opts' + (q.grid ? ' is-grid' : '') + '">';
    q.opts.forEach(function (o) {
      var picked = self.answers[q.id] === o.v ? ' is-picked' : '';
      html += '<button type="button" class="tpq__opt' + picked + '" data-v="' + esc(o.v) + '">' +
        '<span class="tpq__emoji" aria-hidden="true">' + o.e + '</span><span>' + esc(o.t) +
        (o.s ? '<span class="tpq__optsub">' + esc(o.s) + '</span>' : '') + '</span></button>';
    });
    html += '</div>';
    if (this.step > 0) html += '<div class="tpq__nav"><button type="button" class="tpq__link" data-back>← Back</button></div>';
    this.stage.innerHTML = html;
    this.stage.hidden = false;
    this.resultsEl.hidden = true;

    this.stage.querySelectorAll('.tpq__opt').forEach(function (btn) {
      btn.addEventListener('click', function () { self.pick(q.id, btn.getAttribute('data-v'), btn); });
    });
    var back = this.stage.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () { self.step = Math.max(0, self.step - 1); self.renderQuestion(); });
  };

  Quiz.prototype.pick = function (qid, value, btn) {
    var self = this;
    if (!this.started) { this.started = true; track('coffee_quiz_started', { is_retake: !!this.retake }); }
    this.answers[qid] = value;
    if (qid === 'brew') {
      if (value === 'espresso') this.answers.grind = 'whole';
      else if (this.answers.grind === 'whole' && this.autoWhole) delete this.answers.grind;
      this.autoWhole = value === 'espresso';
    }
    track('coffee_quiz_step', { question_number: this.step + 1, question_name: qid, answer: value });
    if (btn) btn.classList.add('is-picked');
    setTimeout(function () {
      if (self.step < self.visible().length - 1) {
        self.step += 1;
        self.renderQuestion();
        self.scrollToCard();
      } else {
        self.showResults(false);
      }
    }, 180);
  };

  Quiz.prototype.scrollToCard = function () {
    var top = this.stage.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.6) {
      window.scrollTo({ top: window.scrollY + top - 90, behavior: 'smooth' });
    }
  };

  Quiz.prototype.target = function () {
    var t = { roast: 3, acidity: 3, body: 3, sweetness: 3 };
    var a = this.answers;
    QUESTIONS.forEach(function (q) {
      var opt = q.opts.filter(function (o) { return o.v === a[q.id]; })[0];
      if (!opt) return;
      Object.keys(opt.n || {}).forEach(function (k) { t[k] += opt.n[k]; });
    });
    Object.keys(t).forEach(function (k) { t[k] = clamp(t[k], 1, 5); });
    return t;
  };

  Quiz.prototype.flavorHits = function (coffee) {
    var words = FLAVOR_WORDS[this.answers.flavor] || [];
    var hay = (coffee.notes + ' ' + coffee.desc).toLowerCase();
    var hits = [];
    words.forEach(function (w) { if (hay.indexOf(w) !== -1) hits.push(w); });
    return hits;
  };

  Quiz.prototype.score = function (coffee, target) {
    var a = this.answers;
    var s = 100;
    Object.keys(WEIGHTS).forEach(function (k) {
      var v = coffee[k];
      if (v === null || v === undefined || isNaN(v)) return;
      s -= Math.abs(target[k] - Number(v)) * 10 * WEIGHTS[k];
    });
    s += Math.min(this.flavorHits(coffee).length, 2) * 8;
    if (a.brew === 'espresso' && coffee.espresso) s += 10;
    if (a.adventure === 'classic' && coffee.kind === 'blend') s += 8;
    if (a.adventure === 'some' && coffee.kind === 'single') s += 4;
    if (a.adventure === 'surprise' && coffee.kind === 'single') s += 10;
    s += Math.min(Number(coffee.ratingCount) || 0, 30) / 10; // small nudge toward proven favorites
    if (coffee.favorite) s += Number(this.settings.favoriteBoost != null ? this.settings.favoriteBoost : 8); // core coffees tagged quiz-favorite
    return s;
  };

  Quiz.prototype.rank = function () {
    var self = this;
    var target = this.target();
    var a = this.answers;
    var scored = this.coffees.map(function (c) { return { c: c, s: self.score(c, target) }; })
      .sort(function (x, y) { return y.s - x.s; });
    var decafs = scored.filter(function (x) { return x.c.decaf; });
    var regular = scored.filter(function (x) { return !x.c.decaf; });
    // Espresso drinkers: lead with our house espresso (Abstract)
    if (a.brew === 'espresso') {
      var house = this.houseEspresso();
      if (house) {
        regular = regular.filter(function (x) { return x.c !== house; });
        regular.unshift({ c: house, s: 999 });
      }
    }
    var picks;
    if (a.caffeine === 'decaf') {
      picks = decafs.length ? decafs : regular;
    } else {
      picks = regular.length ? regular.slice() : scored.slice();
      if (a.caffeine === 'later' && decafs.length) {
        picks = picks.slice(0, 2).concat([decafs[0]]);
      }
    }
    return picks.slice(0, 3).map(function (x) { return x.c; });
  };

  Quiz.prototype.houseEspresso = function () {
    var list = this.coffees.filter(function (c) { return !c.decaf && c.variants.some(function (v) { return v.available; }); });
    return list.filter(function (c) { return /\/products\/abstract/i.test(c.url || '') || /abstract/i.test(c.title || ''); })[0] ||
      list.filter(function (c) { return c.espresso; })[0] || null;
  };

  Quiz.prototype.reasons = function (c) {
    var a = this.answers;
    var out = [];
    var hits = this.flavorHits(c);
    var notes = splitNotes(c.notes);
    if (hits.length && notes.length) out.push('Tastes like ' + notes.slice(0, 3).join(', ').toLowerCase());
    if ((a.take === 'milk' || a.take === 'sweet') && Number(c.body) >= 4) out.push('Full body that holds up to milk');
    if (a.take === 'black' && Number(c.acidity) >= 4) out.push('Bright and clean when you drink it black');
    if (a.take === 'black' && Number(c.acidity) <= 2) out.push('Smooth and never bitter black');
    if (a.brew === 'espresso' && c === this.houseEspresso()) out.push('The espresso we pull in our own cafés');
    else if (a.brew === 'espresso' && c.espresso) out.push('Built for espresso');
    if (a.brew === 'cold' && Number(c.acidity) <= 3) out.push('Smooth and sweet as cold brew');
    if (a.brew === 'pourover' && Number(c.acidity) >= 3) out.push('Shines in a pour over');
    if (a.brew === 'french' && Number(c.body) >= 4) out.push('Rich and full in a French press');
    if (c.decaf && a.caffeine !== 'full') out.push('All the flavor, none of the buzz');
    if (c.kind === 'single' && a.adventure !== 'classic') out.push('A single origin worth exploring');
    if (c.kind === 'blend' && a.adventure === 'classic') out.push('An easy everyday favorite');
    if (!out.length) out.push('Balanced, sweet and easy to love');
    return out.slice(0, 3);
  };

  // ---------- variants ----------
  Quiz.prototype.sizesFor = function (c) {
    var seen = {}, sizes = [];
    c.variants.forEach(function (v) {
      var s = v.options[c.sizeIndex];
      if (s && !seen[s]) { seen[s] = 1; sizes.push(s); }
    });
    return sizes;
  };
  Quiz.prototype.grindsFor = function (c) {
    if (c.grindIndex < 0) return [];
    var seen = {}, g = [];
    c.variants.forEach(function (v) {
      var s = v.options[c.grindIndex];
      if (s && !seen[s]) { seen[s] = 1; g.push(s); }
    });
    return g;
  };
  Quiz.prototype.defaultGrind = function (c) {
    var grinds = this.grindsFor(c);
    if (!grinds.length) return null;
    var wantGround = this.answers.grind === 'ground' && !this.isEspresso();
    var match = grinds.filter(function (g) {
      var l = g.toLowerCase();
      return wantGround ? (l.indexOf('ground') !== -1) : (l.indexOf('whole') !== -1);
    });
    return match[0] || grinds[0];
  };
  Quiz.prototype.findVariant = function (c, size, grind) {
    return c.variants.filter(function (v) {
      return v.options[c.sizeIndex] === size && (c.grindIndex < 0 || !grind || v.options[c.grindIndex] === grind);
    })[0] || null;
  };
  Quiz.prototype.minPrice = function (c) {
    var p = c.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
    return p.length ? Math.min.apply(null, p) : (c.variants[0] ? c.variants[0].price : 0);
  };

  // ---------- results ----------
  Quiz.prototype.showResults = function (restored) {
    var self = this;
    var picks = this.rank();
    var fmt = this.settings.moneyFormat;
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ done: true, answers: this.answers })); } catch (e) {}

    this.stage.hidden = true;
    this.resultsEl.hidden = false;

    if (!picks.length) {
      this.resultsEl.innerHTML = '<div class="tpq__card tpq__empty"><h2 class="tpq__q">We\'re restocking!</h2><p>Our coffees are being roasted right now. <a href="/collections/coffee">Browse the lineup</a>.</p></div>';
      return;
    }

    var top = picks[0];
    this.top = top;
    this.picks = picks;
    if (!restored) {
      track('coffee_quiz_completed', {
        matched_product: top.title,
        runner_ups: picks.slice(1).map(function (p) { return p.title; }).join(', '),
        take: this.answers.take, brew_method: this.answers.brew, grind: this.answers.grind,
        flavor: this.answers.flavor, adventure: this.answers.adventure, caffeine: this.answers.caffeine
      });
      this.saveCartAttribute(top.title);
    }

    var notes = splitNotes(top.notes);
    var sizes = this.sizesFor(top);
    var grinds = this.grindsFor(top);
    this.sel = { size: sizes[0], grind: this.defaultGrind(top) };
    var stars = top.rating > 0 ? '<div class="tpq__stars"><b aria-hidden="true">★★★★★</b><span>' + Number(top.rating).toFixed(1) + (top.ratingCount ? ' · ' + top.ratingCount + ' review' + (top.ratingCount == 1 ? '' : 's') : '') + '</span></div>' : '';
    var espressoMode = this.isEspresso();
    if (espressoMode) {
      // Only offer whole bean for espresso
      grinds = grinds.filter(function (g) { return g.toLowerCase().indexOf('whole') !== -1; });
    }
    var groundNote = (this.answers.grind === 'ground' && ['french', 'cold'].indexOf(this.answers.brew) !== -1)
      ? '<p class="tpq__optsub" style="margin-top:6px">Heads up: our ground coffee is set for drip machines. For ' + ({ french: 'French press', cold: 'cold brew' })[this.answers.brew] + ', whole bean ground fresh at home tastes best.</p>' : '';
    var espressoNote = espressoMode
      ? '<div class="tpq__label">Grind</div><p class="tpq__optsub" style="margin:4px 0 0"><strong>Whole bean.</strong> Espresso needs a much finer grind than our drip grind, so grind it fresh right before you pull your shot.</p>' : '';

    var html = '<div class="tpq__hero">' +
      (top.image ? '<img class="tpq__heroimg" src="' + esc(top.image) + '" alt="' + esc(top.imageAlt) + '" loading="eager">' : '') +
      '<div class="tpq__herobody">' +
      '<span class="tpq__badge">' + esc(this.settings.resultEyebrow || 'Your match') + '</span>' +
      '<h2 class="tpq__rname">' + esc(top.title) + '</h2>' +
      (notes.length ? '<div class="tpq__chips">' + notes.map(function (n) { return '<span class="tpq__chip">' + esc(n) + '</span>'; }).join('') + '</div>' : '') +
      stars +
      '<div class="tpq__why"><strong>Why it\'s your match</strong>' + this.reasons(top).map(esc).join(' · ') + '</div>' +
      (top.desc ? '<p class="tpq__desc">' + esc(top.desc) + '</p>' : '') +
      '<div class="tpq__label">Size</div><div class="tpq__seg" data-seg="size">' +
      sizes.map(function (s) {
        var v = self.findVariant(top, s, self.sel.grind);
        return '<button type="button" class="tpq__segbtn' + (s === self.sel.size ? ' is-on' : '') + '" data-val="' + esc(s) + '"' + (v && !v.available ? ' disabled' : '') + '>' + esc(s) + (v ? '<small>' + formatMoney(v.price, fmt) + '</small>' : '') + '</button>';
      }).join('') + '</div>' +
      (grinds.length > 1 ? '<div class="tpq__label">Grind</div><div class="tpq__seg" data-seg="grind">' +
        grinds.map(function (g) { return '<button type="button" class="tpq__segbtn' + (g === self.sel.grind ? ' is-on' : '') + '" data-val="' + esc(g) + '">' + esc(g) + '</button>'; }).join('') + '</div>' + groundNote : '') +
      espressoNote +
      '<button type="button" class="tpq__atc" data-atc>Add to cart</button>' +
      '<a class="tpq__more" href="' + esc(top.url) + '">See full details →</a>' +
      '</div></div>';

    var alts = picks.slice(1);
    var emailOn = !!(this.settings.showEmail && this.settings.klaviyoCompanyId);
    var unlocked = !emailOn || this.isUnlocked();
    this.locked = !unlocked;

    // Email box sits right under the top match
    if (emailOn) {
      if (unlocked) {
        html += '<div class="tpq__email is-done" data-email-box><h3>' + esc(this.settings.emailThanks || 'You\'re in!') + '</h3></div>';
      } else {
        html += '<div class="tpq__email" data-email-box><h3>' + esc(this.settings.emailHeading) + '</h3><p>' + esc(this.settings.emailText) + '</p>' +
          '<form class="tpq__form" data-email-form novalidate><input type="email" name="email" placeholder="you@email.com" autocomplete="email" required aria-label="Email address">' +
          '<button type="submit">' + esc(this.settings.emailButton || 'Unlock') + '</button></form>' +
          '<div class="tpq__fine">No spam. Unsubscribe anytime.</div></div>';
      }
    }

    if (alts.length) {
      html += '<div class="tpq__altwrap' + (unlocked ? '' : ' is-locked') + '" data-alts>' +
        '<h3 class="tpq__h3">You\'d also love</h3>' +
        (unlocked ? '' : '<div class="tpq__lock" data-lock><span aria-hidden="true">🔒</span> Enter your email above to see your other ' + (alts.length === 1 ? 'match' : alts.length + ' matches') + '</div>') +
        '<div class="tpq__alts"' + (unlocked ? '' : ' aria-hidden="true"') + '>';
      alts.forEach(function (c, i) {
        var label = c.decaf && self.answers.caffeine === 'later' ? 'For your afternoon cup' : (i === 0 ? 'Runner-up' : 'Also a great fit');
        var n = splitNotes(c.notes).slice(0, 3).join(' · ');
        var tab = unlocked ? '' : ' tabindex="-1"';
        html += '<div class="tpq__alt">' +
          (c.image ? '<a href="' + esc(c.url) + '"' + tab + '><img src="' + esc(c.image) + '" alt="' + esc(c.imageAlt) + '" loading="lazy"></a>' : '<span></span>') +
          '<div><div class="tpq__alttag">' + esc(label) + '</div>' +
          '<a class="tpq__altname" href="' + esc(c.url) + '"' + tab + '>' + esc(c.title) + '</a>' +
          (n ? '<div class="tpq__altnotes">' + esc(n) + '</div>' : '') +
          '<div class="tpq__altrow"><span class="tpq__altprice">From ' + formatMoney(self.minPrice(c), fmt) + '</span>' +
          '<button type="button" class="tpq__altadd" data-alt="' + c.id + '"' + tab + '>Add ' + esc(self.sizesFor(c)[0] || '') + '</button></div></div></div>';
      });
      html += '</div></div>';
    }

    html += '<button type="button" class="tpq__link tpq__restart" data-restart>Retake the quiz</button>';
    this.resultsEl.innerHTML = html;
    if (this.intro) this.intro.hidden = true;

    // wire up
    this.resultsEl.querySelectorAll('[data-seg]').forEach(function (seg) {
      seg.addEventListener('click', function (e) {
        var b = e.target.closest('.tpq__segbtn');
        if (!b || b.disabled) return;
        self.sel[seg.getAttribute('data-seg')] = b.getAttribute('data-val');
        seg.querySelectorAll('.tpq__segbtn').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        self.updateAtcLabel();
      });
    });
    this.updateAtcLabel();
    var atc = this.resultsEl.querySelector('[data-atc]');
    atc.addEventListener('click', function () {
      var v = self.findVariant(top, self.sel.size, self.sel.grind);
      if (v) self.addToCart(v, atc, top);
    });
    this.resultsEl.querySelectorAll('[data-alt]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (self.locked) return;
        var c = picks.filter(function (p) { return String(p.id) === b.getAttribute('data-alt'); })[0];
        if (!c) return;
        var size = self.sizesFor(c)[0];
        var v = self.findVariant(c, size, self.defaultGrind(c)) || c.variants.filter(function (x) { return x.available; })[0];
        if (v) self.addToCart(v, b, c);
      });
    });
    var form = this.resultsEl.querySelector('[data-email-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.submitEmail(form); });
    this.resultsEl.querySelector('[data-restart]').addEventListener('click', function () { self.restart(); });

    if (!restored) {
      var r = this.resultsEl.getBoundingClientRect().top;
      window.scrollTo({ top: window.scrollY + r - 80, behavior: 'smooth' });
    }
  };

  Quiz.prototype.isUnlocked = function () {
    try { return localStorage.getItem('tpq_unlocked_v1') === '1'; } catch (e) { return false; }
  };

  Quiz.prototype.unlock = function () {
    try { localStorage.setItem('tpq_unlocked_v1', '1'); } catch (e) {}
    this.locked = false;
    var wrap = this.resultsEl.querySelector('[data-alts]');
    if (!wrap) return;
    wrap.classList.remove('is-locked');
    var lock = wrap.querySelector('[data-lock]');
    if (lock) lock.remove();
    var list = wrap.querySelector('.tpq__alts');
    if (list) list.removeAttribute('aria-hidden');
    wrap.querySelectorAll('[tabindex="-1"]').forEach(function (el) { el.removeAttribute('tabindex'); });
    setTimeout(function () {
      var r = wrap.getBoundingClientRect().top;
      window.scrollTo({ top: window.scrollY + r - 90, behavior: 'smooth' });
    }, 350);
  };

  Quiz.prototype.updateAtcLabel = function () {
    var btn = this.resultsEl.querySelector('[data-atc]');
    if (!btn || !this.top) return;
    var v = this.findVariant(this.top, this.sel.size, this.sel.grind);
    if (!v || !v.available) { btn.disabled = true; btn.textContent = 'Sold out'; return; }
    btn.disabled = false;
    btn.textContent = 'Add to cart · ' + formatMoney(v.price, this.settings.moneyFormat);
  };

  Quiz.prototype.addToCart = function (variant, btn, product) {
    var self = this;
    var variantId = variant.id;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      track('coffee_quiz_add_to_cart', {
        matched_product: self.top ? self.top.title : '',
        product_added: product.title,
        is_match: !!(self.top && product.id === self.top.id),
        variant: (variant.title || (variant.options || []).join(' / ')),
        variant_id: String(variantId),
        quantity: 1,
        value: Math.round(variant.price) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
      var state = window.VanillaCartState;
      var refresh = state && typeof state.fetchCart === 'function' ? state.fetchCart() : Promise.resolve();
      return Promise.resolve(refresh).then(function () {
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer(btn);
        else window.location.href = '/cart';
      });
    }).catch(function (err) {
      alert(err.message || 'Sorry, something went wrong. Please try again.');
    }).finally(function () {
      btn.disabled = false;
      btn.textContent = label;
    });
  };

  Quiz.prototype.saveCartAttribute = function (match) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Quiz match': match } })
      });
    } catch (e) {}
  };

  Quiz.prototype.submitEmail = function (form) {
    var self = this;
    var input = form.querySelector('input[type=email]');
    var btn = form.querySelector('button');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { input.focus(); input.style.outline = '2px solid #e5484d'; return; }
    input.style.outline = '';
    btn.disabled = true;
    var props = {
      quiz_match: this.top ? this.top.title : '',
      quiz_match_url: this.top ? location.origin + this.top.url : '',
      quiz_runner_ups: (this.picks || []).slice(1).map(function (p) { return p.title; }).join(', '),
      quiz_brew_method: this.answers.brew || '',
      quiz_grind: this.answers.grind || '',
      quiz_takes_it: this.answers.take || '',
      quiz_flavor: this.answers.flavor || '',
      quiz_caffeine: this.answers.caffeine || '',
      quiz_completed_at: new Date().toISOString()
    };
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Coffee Quiz',
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        }
      }
    };
    if (this.settings.klaviyoListId) body.data.relationships = { list: { data: { type: 'list', id: this.settings.klaviyoListId } } };

    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(Object.assign({ email: email }, props)); } catch (e) {}

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.settings.klaviyoCompanyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
      try { if (window.klaviyo && window.klaviyo.track) window.klaviyo.track('Completed Coffee Quiz', props); } catch (e) {}
      if (!self.emailTracked) { self.emailTracked = true; track('coffee_quiz_email_submitted', { matched_product: props.quiz_match }); }
      var box = self.resultsEl.querySelector('[data-email-box]');
      box.classList.add('is-done');
      box.innerHTML = '<h3>' + esc(self.settings.emailThanks || 'You\'re in!') + '</h3>';
      self.unlock();
    }).catch(function () {
      // Don't leave the shopper stuck if Klaviyo is unreachable: still show their matches
      btn.disabled = false;
      btn.textContent = 'Try again';
      self.unlock();
    });
  };

  Quiz.prototype.restart = function () {
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    this.answers = {};
    this.step = 0;
    this.started = false;
    this.retake = true;
    if (this.intro) this.intro.hidden = false;
    this.renderQuestion();
    var r = this.root.getBoundingClientRect().top;
    window.scrollTo({ top: window.scrollY + r - 60, behavior: 'smooth' });
  };

  function init() {
    document.querySelectorAll('[data-tpq]').forEach(function (el) {
      if (el.__tpq) return;
      el.__tpq = new Quiz(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();